import { isDocustream } from "./core";

const LANGUAGES = ["fr", "en"] as const;
type Language = (typeof LANGUAGES)[number];

type LegalLinks = Record<Language, string>;

export const isValidLang = (lang: string | undefined): lang is Language => {
  if (!lang) return false;
  return LANGUAGES.includes(lang as Language);
};

export const getTermsOfServiceLinks = (): LegalLinks => {
  return isDocustream()
    ? {
        fr: "https://cdn.libertify.com/env/legal/fr/Docustream_Media_Platform_CGV_FR_20250310.pdf",
        en: "https://cdn.libertify.com/env/legal/en/Docustream_Media_Platform_TOS_EN_20250310.pdf",
      }
    : {
        fr: "https://www.libertify.com/fr/terms-conditions/",
        en: "https://www.libertify.com/terms-conditions/",
      };
};

export const getPrivacyPolicyLinks = (): LegalLinks => {
  return isDocustream()
    ? {
        fr: "https://cdn.libertify.com/env/legal/fr/Docustream_Protection_des+donne%CC%81es_RGPD_20250310.pdf",
        en: "https://cdn.libertify.com/env/legal/en/Docustream_Data_protection+policy_Article28_GDPR_20250310.pdf",
      }
    : {
        fr: "https://www.libertify.com/fr/privacy-policy/",
        en: "https://www.libertify.com/privacy-policy/",
      };
};
